import { InternalLink } from "../../../../src/components/link.js";
import compilerComplaintComic from "../../../../src/images/compiler_complaint.png";
import { HashLink } from "../../../../src/components/link";
import * as React from 'react';
export default {
  InternalLink,
  compilerComplaintComic,
  HashLink,
  React
};